import { css } from 'styled-components';

export const antdSlider = css`
  .ant-slider {
    margin-top: 0;
    margin-bottom: 0;
    &:hover .ant-slider-track {
      background-color: ${({ theme }) => theme.baseBlue.a7};
    }
  }

  .ant-slider-handle {
    cursor: pointer;
    width: 15px;
    height: 15px;
    background-color: ${({ theme }) => theme.baseBlue.a10};
    border: none;
    &:focus {
      box-shadow: 0 0 0 5px ${({ theme }) => theme.baseBlue.a3};
    }

    &.ant-tooltip-open {
      background-color: ${({ theme }) => theme.baseBlue.a10};
    }
  }
  .ant-slider-track {
    background-color: ${({ theme }) => theme.baseBlue.a10};
  }
`;
